import axios from '@/lib/AxApi';

export default {
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/WorkingGroups/selectRow',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async submitData(params)
    {
        try
        {
            let func = 'insertRow';
            if (typeof params.id !== 'undefined' && params.id !== '')
            {
                func = 'updateRow';
            }

            const response = await axios.post(`/WorkingGroups/${func}`, params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/WorkingGroups/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async selectChildrenInGroup(params)
    {
        try
        {
            const response = await axios.get('/WorkingGroups/selectChildrenInGroup',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async selectChildren(params)
    {
        try
        {
            const response = await axios.get('/WorkingGroups/selectChildren',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async upsertChild(params)
    {
        try
        {
            const response = await axios.post('/WorkingGroups/upsertChild', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async updateOrderNumber(params)
    {
        try
        {
            const response = await axios.post('/WorkingGroups/updateOrderNumber', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async upsertWorkingGroupEvent(params)
    {
        try
        {
            const response = await axios.post('/WorkingGroups/upsertWorkingGroupEvent', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async selectWorkingGroupEvent(params)
    {
        try
        {
            const response = await axios.get('/WorkingGroups/selectWorkingGroupEvent',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async upsertChildEventAttendance(params)
    {
        try
        {
            const response = await axios.post('/WorkingGroups/upsertChildEventAttendance', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },

    exportData(params, cb)
    {
        window.open('/WorkingGroups/exportChildrenToPdf?query=' + JSON.stringify(params));
    }
};
